<template>
    <div id="nav">
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link> | 
    <!-- <router-link to="/login">Login</router-link> |  -->
    <router-link to="/logout">Logout</router-link>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>